// 侧栏的折叠状态（#145，用户 2026-09-26 要求）：整栏可收成图标条，各分组可收起，浏览器都记住。
// 进入一个页面时它所在的分组自动展开，免得当前页藏在收起的分组里；之后用户仍可以把它收起。
// 自动展开只改内存、不写存储（渲染期间不做副作用）；用户下一次点分组时把当前的收起列表整个写回，
// 那时自动展开过的分组就不再记为收起。这是有意的：用户看过它展开的样子，没有再收起就按展开记。
import { useState } from "react";
import { readPref, writePref } from "@/app/storage";

const RAIL_KEY = "axon.nav.collapsed";
const GROUPS_KEY = "axon.nav.closedGroups";

/** 读记住的已收起分组，格式不对时按全部展开。 */
function storedClosed(): string[] {
  try {
    const v: unknown = JSON.parse(readPref(GROUPS_KEY) ?? "[]");
    return Array.isArray(v) ? v.filter((t): t is string => typeof t === "string") : [];
  } catch {
    return [];
  }
}

/** 侧栏的收起状态与各分组的展开状态，以及切换它们的方法。activeGroup 是当前页面所在分组的标题，不在导航里的页面传 undefined。 */
export function useSidebar(activeGroup: string | undefined) {
  const [collapsed, setCollapsedState] = useState(() => readPref(RAIL_KEY) === "1");
  const [closed, setClosed] = useState(() => storedClosed().filter((t) => t !== activeGroup));
  // 换到别的分组的页面时展开那个分组：在渲染时比较上一次的分组，不用 effect
  const [seen, setSeen] = useState(activeGroup);
  if (seen !== activeGroup) {
    setSeen(activeGroup);
    if (activeGroup && closed.includes(activeGroup)) setClosed(closed.filter((t) => t !== activeGroup));
  }

  return {
    collapsed,
    setCollapsed(v: boolean) {
      setCollapsedState(v);
      writePref(RAIL_KEY, v ? "1" : "0");
    },
    isOpen: (title: string) => !closed.includes(title),
    toggle(title: string) {
      const next = closed.includes(title) ? closed.filter((t) => t !== title) : [...closed, title];
      setClosed(next);
      writePref(GROUPS_KEY, JSON.stringify(next));
    },
  };
}
